import script from "./FileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileMenu.vue?vue&type=script&setup=true&lang=ts"

import "./FileMenu.vue?vue&type=style&index=0&id=049331eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049331eb"]])

export default __exports__